export const MIN_PLATFORM_FEE_PERCENT = 0
export const MAX_PLATFORM_FEE_PERCENT = 99

export function clampPlatformFeePercent(value) {
  if (value === '' || value === null || value === undefined) return value
  const n = Number(value)
  if (!Number.isFinite(n)) return MIN_PLATFORM_FEE_PERCENT
  if (n < MIN_PLATFORM_FEE_PERCENT) return MIN_PLATFORM_FEE_PERCENT
  if (n > MAX_PLATFORM_FEE_PERCENT) return MAX_PLATFORM_FEE_PERCENT
  return n
}

export function getPlatformFeePercent(value) {
  const clamped = clampPlatformFeePercent(value)
  return typeof clamped === 'number' ? clamped : MIN_PLATFORM_FEE_PERCENT
}

export function calcPlatformFeeAmount(charge, percent) {
  const c = Math.max(0, Number(charge) || 0)
  const p = getPlatformFeePercent(percent)
  const fee = (c * p) / 100
  return Number(Math.min(fee, c).toFixed(2))
}

export function calcNetReceive(charge, percent) {
  const c = Math.max(0, Number(charge) || 0)
  const fee = calcPlatformFeeAmount(c, percent)
  return Number(Math.max(0, c - fee).toFixed(2))
}

export function calcChargeFromNetReceive(netReceive, percent) {
  const received = Math.max(0, Number(netReceive) || 0)
  const p = getPlatformFeePercent(percent)
  if (p >= 100) return received
  const divisor = 1 - p / 100
  if (divisor <= 0) return received
  return Number((received / divisor).toFixed(2))
}

export function getPlatformFeeError(value, { required = true } = {}) {
  if (value === '' || value === null || value === undefined) {
    return required ? 'Platform fee is required' : ''
  }
  const n = Number(value)
  if (!Number.isFinite(n)) return 'Enter a valid platform fee percentage'
  if (n < MIN_PLATFORM_FEE_PERCENT) return 'Platform fee cannot be negative'
  if (n > MAX_PLATFORM_FEE_PERCENT) {
    return `Platform fee cannot be more than ${MAX_PLATFORM_FEE_PERCENT}%`
  }
  return ''
}
